
const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Material Header',
  description: 'Material Invoice upload headers',
  sortOrder: 1,
  name: 'materialHeader',
  documentKey: 'material_header',
  values: {
    material_ref_id: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'material_ref_id',
      displayName: 'material_ref_id',
      documentKey: 'material_ref_id',
    },
    material_code: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'material_code',
      displayName: 'material_code',
      documentKey: 'material_code',
    },
    quantity: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'quantity',
      displayName: 'quantity',
      documentKey: 'quantity',
    },
    quantity_unit: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'quantity_unit',
      displayName: 'quantity_unit',
      documentKey: 'quantity_unit',
    },
    weight: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'weight',
      displayName: 'weight',
      documentKey: 'weight',
    },
    weight_unit: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'weight_unit',
      displayName: 'weight_unit',
      documentKey: 'weight_unit',
    },
    volume: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'volume',
      displayName: 'volume',
      documentKey: 'volume',
    },
    volume_unit: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'volume_unit',
      displayName: 'volume_unit',
      documentKey: 'volume_unit',
    },
    pickup_point: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'pickup_point',
      displayName: 'pickup_point',
      documentKey: 'pickup_point',
    },
    category: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'category',
      displayName: 'category',
      documentKey: 'category',
    },
    ship_to: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'ship_to',
      displayName: 'ship_to',
      documentKey: 'ship_to',
    },
    sold_to: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'sold_to',
      displayName: 'sold_to',
      documentKey: 'sold_to',
    },
    invoice_amount: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'invoice_amount',
      displayName: 'invoice_amount',
      documentKey: 'invoice_amount',
    },
    invoice_number: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'invoice_number',
      displayName: 'invoice_number',
      documentKey: 'invoice_number',
    },
    invoice_date: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'invoice_date',
      displayName: 'invoice_date',
      documentKey: 'invoice_date',
    },
    mrp: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'mrp',
      displayName: 'mrp',
      documentKey: 'mrp',
    },
  },
};
